export default __webpack_public_path__ + "static/media/63.4f284d1d.jpg";